import { Badge } from "@chakra-ui/react";

const STATUS_STYLES = {
    active: { bg: "green.500", borderColor: "green.200", label: "Aktywna" },
    draft: { bg: "gray.600", borderColor: "gray.400", label: "Wersja robocza" },
    inactive: { bg: "orange.500", borderColor: "orange.200", label: "Wstrzymana" },
};

export const CampaignStatusBadge = ({ status, badgeStyles }) => {
    const key = status?.toLowerCase();
    const { bg, borderColor, label } = STATUS_STYLES[key] ?? STATUS_STYLES.inactive;

    return (
        <Badge bg={bg} borderColor={borderColor} borderWidth={1} variant="subtle" fontSize="xs" px={3} py={0.5} borderRadius={6} {...badgeStyles}>
            {label}
        </Badge>
    );
};

export default CampaignStatusBadge;
